import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

export const usePopState = () => {
  const popState = useRef(false);
  const router = useRouter();

  useEffect(() => {
    router.beforePopState(() => {
      popState.current = true;
      return true;
    });
  }, []);

  function resetPopState() {
    popState.current = false;
  }

  return { isPopState: popState.current, resetPopState };
};
